module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/item-7-4b1b19e6bbbff79e648fac6113a05965.jpg";